/**
 * Base URL for API endpoints
 * Fetched from environment variables or defaults to empty string
 */
export const baseUrl = process.env.REACT_APP_BASE_URL || '';

/**
 * API endpoint configuration object
 * Contains all available API endpoints organized by feature
 */
export const api = {
  /**
   * Authentication related endpoints
   */
  auth: {
    /** User login endpoint */
    login: `${baseUrl}login`,
    /** Update user profession endpoint */
    updateProfession: `${baseUrl}update-profession`,
  },
  /**
   * Question and answer related endpoints
   */
  qna: {
    /** Get categories endpoint */
    categories: 'categories',
    /** Chat history endpoint */
    chats: 'chats',
    /** Chat messages endpoint */
    chatMessages: 'messages',
    /** Ask question endpoint */
    ask: 'qna/ask',
    /** Streaming question endpoint */
    askStreaming: baseUrl + '/v3/stream/ask',
    /** Developer messages endpoint */
    devMessages: 'dev_message',
    /** Metadata endpoint */
    metadata: baseUrl + '/api/metadata?url=',
    /** Share chat endpoint */
    share: 'share_chat/',
    /** Public chat endpoint */
    publicChat: 'shared/messages/',
    /** Toggle favorite status endpoint */
    toggleFavorite: 'favorite_chat',
    /** Remove chat endpoint */
    removeChat: 'delete_chat',
  },
  /**
   * Tabs related endpoints
   */
  tabs: {
    /** Get all tabs endpoint */
    getAll: `${baseUrl}api/tabs`,
    /**
     * Get categories for a specific tab
     * @param {number} tabId - ID of the tab to get categories for
     * @returns {string} The API endpoint URL
     */
    categories: (tabId: number) => `${baseUrl}api/tabs/${tabId}/categories`,
  },
};
